import styled from "styled-components";

export const Lista = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  border-bottom: 2px solid #EFF0F2;

  /* Sem herdar o verde de "todo botão da página" do CSS antigo (.content button). */
  button[role="tab"]{
    width: auto;
    height: auto;
    margin: 0 0 -2px 0 !important;
    padding: 10px 18px;
    border: none;
    border-bottom: 3px solid transparent;
    border-radius: 0;
    background: transparent;
    color: #4D4F50;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:hover{ color: var(--primary-color); background: transparent; }
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: -2px; border-radius: 4px; }

    .selo-aba{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 18px;
      height: 18px;
      margin-left: 8px;
      padding: 0 5px;
      border-radius: 9px;
      background: #C43333;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      line-height: 1;
      vertical-align: middle;
    }

    &.ativa{
      color: var(--primary-color);
      border-bottom-color: var(--primary-color);
    }
  }
`;
